import { render, staticRenderFns } from "./MasterProductList.vue?vue&type=template&id=6d2a61fe&scoped=true&"
import script from "./MasterProductList.vue?vue&type=script&lang=js&"
export * from "./MasterProductList.vue?vue&type=script&lang=js&"
import style0 from "./MasterProductList.vue?vue&type=style&index=0&id=6d2a61fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a61fe",
  null
  
)

/* custom blocks */
import block0 from "./MasterProductList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VContainer,VProgressLinear,VVirtualScroll})
